import * as React from 'react';
import './StatsMapPopups.scss';
import { MaterialStatsTable } from '../stats/MaterialStatsTable';
import { ITripStat, StatsStore } from '@pages/trucks/store/StatsStore';
import { FilterStore } from '@pages/trucks/store/FilterStore';
import { DateUtils } from '@shared/utils/DateUtils';
import { observer } from 'mobx-react';
import { DateSpan } from '@shared/ui-react/UtilComponents';
import { GeofenceType } from '@shared/trucks/GeofenceFeatureFactory';
import { AreaBalancesTable } from '@pages/trucks/stats/AreaBalancesTable';
import { makeObservable, observable } from 'mobx';

@observer
export class StatsGeofenceMapPopups extends React.Component<{
    geofence: IGeofence;
}> {
    statsFilterLoaded: FilterStore = new FilterStore();
    statsFilterUnloaded: FilterStore = new FilterStore();
    statsStoreLoaded: StatsStore = new StatsStore(this.statsFilterLoaded);
    statsStoreUnloaded: StatsStore = new StatsStore(this.statsFilterUnloaded);
    @observable isLoaded = false;

    constructor(props: any) {
        super(props);
        makeObservable(this);
    }

    componentDidMount() {
        this.initStatsFilter(this.statsFilterLoaded);
        this.initStatsFilter(this.statsFilterUnloaded);
        this.statsFilterLoaded.focusLoadArea(this.props.geofence.id);
        this.statsFilterUnloaded.focusUnloadArea(this.props.geofence.id);

        const fetches = [];

        if (this.showLoadedStats) {
            fetches.push(this.statsStoreLoaded.fetch());
        }
        if (this.showUnloadedStats) {
            fetches.push(this.statsStoreUnloaded.fetch());
        }

        Promise.all(fetches).then(() => {
            this.isLoaded = true;
        });
    }

    render() {
        const { geofence } = this.props;
        const loadedSummary = this.isLoaded && this.showLoadedStats ? this.statsStoreLoaded.groupByTimeAndMaterials(this.loadedStats, 'all') : null;
        const unloadedSummary = this.isLoaded && this.showUnloadedStats ? this.statsStoreUnloaded.groupByTimeAndMaterials(this.unloadedStats, 'all') : null;

        return (
            <div className='geofence-map-popup'>
                <div style={{ color: 'black', fontSize: 14, borderBottom: '1px solid #ccc', padding: '6px 0', marginBottom: 20 }}>
                    {!!geofence.materials.length && (
                        <div style={{ maxWidth: 'calc(min(600px, 100vw))', marginBottom: 10 }}>
                            {__('trucks.geofence.materials')}: {geofence.materials.map((material, i) => material.material).join(', ')}
                        </div>
                    )}
                </div>

                <strong>
                    <DateSpan timestamp={this.statsFilterLoaded.fromTimestamp} /> - <DateSpan timestamp={this.statsFilterLoaded.toTimestamp} />
                </strong>
                {this.showLoadedStats && (
                    <div style={{ marginTop: 20 }}>
                        <h5>{__('trucks.stats.loaded_to')}</h5>
                        {loadedSummary && <MaterialStatsTable stats={loadedSummary} groupedBy={'all'} />}
                    </div>
                )}
                {this.showUnloadedStats && (
                    <div style={{ marginTop: 20 }}>
                        <h5>{__('trucks.stats.unloaded_from')}</h5>
                        {unloadedSummary && <MaterialStatsTable stats={unloadedSummary} groupedBy={'all'} />}
                    </div>
                )}
                <hr />
                <h5>{__('trucks.starting_volumes.balance')}</h5>
                <AreaBalancesTable areaUuid={geofence.uuid} />
            </div>
        );
    }

    initStatsFilter(statsFilter: FilterStore) {
        statsFilter.setFromStoresData();
        statsFilter.selectNone();
        statsFilter.setDates(DateUtils.TODAY_START, DateUtils.TODAY_END, null);
    }

    get loadedStats(): ITripStat[] {
        return this.statsStoreLoaded.items.filter(i => i.loadAreaId === this.props.geofence.id);
    }

    get unloadedStats(): ITripStat[] {
        return this.statsStoreUnloaded.items.filter(i => i.unloadAreaId === this.props.geofence.id);
    }

    get showLoadedStats() {
        const type = this.props.geofence?.type;

        return type === GeofenceType.LOAD || type === GeofenceType.HYBRID;
    }

    get showUnloadedStats() {
        const type = this.props.geofence?.type;

        return type === GeofenceType.UNLOAD || type === GeofenceType.HYBRID;
    }
}

/*@observer
export class StatsVehicleMapPopups extends React.Component<{
    vehicle: ITruck,
    mapWrapper: MapWrapper
}> {
    statsFilter: FilterStore = new FilterStore();
    statsStore: StatsStore = new StatsStore(this.statsFilter);

    state = {
        posE: null,
        posN: null,
    };

    componentDidMount() {
        this.statsFilter.setFromStoresData();
        this.statsFilter.selectNone();
        this.statsFilter.setDates(DateUtils.TODAY_START, DateUtils.TODAY_END, 1);
        this.statsFilter.focusVehicle(this.props.vehicle.id, false);
        this.statsStore.fetch();

        Ajax({
            url : 'api/1/project/' + kuura.getProjectId() + '/convert_lat_lon.json',
            data: {
                lat: this.props.vehicle.position.latitude,
                lon: this.props.vehicle.position.longitude
            }
        }).done(resp => {
            this.setState({
                posE: resp.coords.e.toFixed(2),
                posN: resp.coords.n.toFixed(2)
            });
        });

        this.drawPositionTrail();
    }

    componentWillUnmount(): void {
        const vehiclesLayerWrapper = this.props.mapWrapper.featureLayers.vehicles;
        vehiclesLayerWrapper.clearPositionTrail();
    }

    drawPositionTrail = () => {
        this.props.mapWrapper.featureLayers.vehicles.drawPositionTrail(this.props.vehicle.id)
    }

    render() {
        const { vehicle } = this.props;
        const stats = this.statsStore.items.filter(i => i.vehicleId == vehicle.id);
        const summary = this.statsStore.groupByTimeAndMaterials(stats, 'all');

        return (
            <div className='geofence-map-popup stats-for-dates'>
                <div style={{ color: 'black', fontSize: 14, borderBottom: '1px solid #ccc', padding: '6px 0' }}>
                    <div>
                        <header>{vehicle.name}</header>
                        <div>{__('tablet.driver_js')}: {vehicle.driverName || '/'}, {__('tablet.gsm_js')}: {vehicle.driverPhone || '/'}</div>
                        <a style={{ textDecoration: 'underline' }} href={`vehicles.htm#/overview/${vehicle.id}`}
                           target='_blank'>{__('tablet.vehiclepage_js')}</a>
                    </div>

                    <section>
                        <div>lat: {vehicle.position.latitude}, lon: {vehicle.position.longitude}</div>
                        <div>n: {this.state.posN}, e: {this.state.posE}</div>
                        <div>{__('tablet.position_timestamp_js')}: <DateTimeSpan timestamp={vehicle.position.timestamp}/></div>
                        <div>{vehicle.reportAlert && __('tablet.vehicle_old_report_js')}</div>
                    </section>

                    <section>
                        <DateRangePicker store={this.statsFilter}
                                         clearable={true}
                                         onChange={(from, to, presetIndex) => {
                                             this.statsFilter.setDates(from, to, presetIndex);
                                             this.statsStore.fetch();
                                         }}/>
                    </section>
                </div>

                <MaterialStatsTable stats={summary} groupedBy={'all'}/>
            </div>
        );
    }
}*/
